// material-ui
import { styled, useTheme } from '@mui/material/styles';
import { Container, Grid, Typography, Stack } from '@mui/material';
import Link from '@mui/material/Link';

// project imports
import AppBar from 'ui-component/extended/AppBar';
import MainCard from 'ui-component/cards/MainCard';
import { gridSpacing } from 'store/constant';
import FooterSection from '../../../layout/MainLayout/Footer/FooterSection';

// assets
import headerBackground from 'assets/images/landing/bg-header.jpg';

const HeaderWrapper = styled('div')(({ theme }) => ({
    backgroundImage: `url(${headerBackground})`,
    backgroundSize: '100% 600px',
    backgroundAttachment: 'fixed',
    backgroundRepeat: 'no-repeat',
    textAlign: 'center',
    paddingTop: 30,
    [theme.breakpoints.down('md')]: {
        paddingTop: 0
    }
}));

const SectionWrapperFooter = styled('div')({
    paddingTop: 50,
    paddingBottom: 0
});
// ============================|| SAAS PAGES - PRIVCY POLICY ||============================ //

const PrivacyPolicy = () => {
    const theme = useTheme();

    return (
        <HeaderWrapper>
            <AppBar />
            <Container>
                <Grid container justifyContent="center" spacing={gridSpacing}>
                    <Grid item sm={10} md={7} sx={{ mt: { md: 12.5, xs: 2.5 }, mb: { md: 8, xs: 2.5 } }}>
                        <Grid container spacing={gridSpacing}>
                            <Grid item xs={12}>
                                <Typography
                                    variant="h1"
                                    component="div"
                                    color="white"
                                    sx={{
                                        fontSize: '3.5rem',
                                        fontWeight: 900,
                                        lineHeight: 1.4,
                                        [theme.breakpoints.down('md')]: { fontSize: '1.8125rem', marginTop: '80px' }
                                    }}
                                >
                                    CHÍNH SÁCH BẢO MẬT
                                </Typography>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={12}>
                        <MainCard elevation={4} border={false} boxShadow shadow={4} sx={{ mb: 3 }}>
                            <Stack spacing={2} sx={{ textAlign: 'left' }}>
                                <Typography variant="h4">Giới Thiệu: </Typography>
                                <Typography textAlign="justify" variant="body2" style={{ textIndent: '2rem' }}>
                                    Chào mừng bạn đến với YouTeach.AI, một nền tảng trò chuyện dựa trên trí tuệ nhân tạo mà bạn hoàn toàn có
                                    thể tùy chỉnh dữ liệu đầu vào phù hợp với nhu cầu cụ thể, cam kết cung cấp trải nghiệm học tập tương tác
                                    thông qua cuộc trò chuyện và hỗ trợ cá nhân hóa. Chính sách bảo mật của chúng tôi nhằm thông báo cho bạn
                                    về cách chúng tôi xử lý thông tin cá nhân của bạn với sự chăm sóc và tôn trọng tuyệt đối đối với quyền
                                    riêng tư của bạn.
                                </Typography>
                                {/*  */}
                                <Typography variant="h4">
                                    Tên miền website:{' '}
                                    <Link href="https://youteach.ai/" underline="none">
                                        https://youteach.ai/
                                    </Link>{' '}
                                </Typography>
                                {/*  */}
                                <Typography variant="h4">Thu Thập Dữ Liệu: </Typography>
                                <Typography textAlign="justify" variant="body2" style={{ textIndent: '2rem' }}>
                                    Khi bạn sử dụng YouTeach.AI, chúng tôi có thể thu thập các loại dữ liệu cá nhân sau:
                                </Typography>
                                <Typography>
                                    <ol style={{ listStyleType: 'decimal', marginLeft: '4rem' }}>
                                        <li>
                                            <Typography textAlign="justify" variant="body2">
                                                Dữ Liệu Về Định Danh và Liên Hệ: Bao gồm chi tiết như tên và địa chỉ email của bạn, mà bạn
                                                cung cấp tự nguyện khi đăng ký tài khoản hoặc đăng ký sử dụng dịch vụ của chúng tôi.
                                            </Typography>
                                        </li>
                                        <li>
                                            <Typography textAlign="justify" variant="body2">
                                                Dữ Liệu Sử Dụng: Bao gồm thông tin về cách bạn tương tác với nền tảng của chúng tôi, như tần
                                                suất truy cập, các tính năng bạn sử dụng.
                                            </Typography>
                                        </li>
                                        <li>
                                            <Typography textAlign="justify" variant="body2">
                                                Dữ Liệu Kỹ Thuật: Bao gồm địa chỉ giao thức internet (IP), loại thiết bị của bạn, trình
                                                duyệt, cài đặt múi giờ, và dữ liệu đăng nhập được tự động thu thập khi bạn duyệt qua trang
                                                web.
                                            </Typography>
                                        </li>
                                    </ol>
                                </Typography>
                                <Typography textAlign="justify" variant="body2" style={{ textIndent: '2rem' }}>
                                    Chúng tôi sử dụng cookies và các công nghệ theo dõi tương tự để theo dõi hoạt động trên Dịch vụ của
                                    chúng tôi và giữ một số thông tin.
                                </Typography>
                                <Typography textAlign="justify" variant="body2" style={{ textIndent: '2rem' }}>
                                    Cookies là các tệp chứa một lượng nhỏ dữ liệu có thể bao gồm một định danh duy nhất ẩn danh. Cookies
                                    được gửi đến trình duyệt của bạn từ một trang web và lưu trữ trên thiết bị của bạn.
                                </Typography>
                                <Typography textAlign="justify" variant="body2" style={{ textIndent: '2rem' }}>
                                    Bạn có thể hướng dẫn trình duyệt của mình từ chối tất cả cookies hoặc báo hiệu khi một cookie đang được
                                    gửi.
                                </Typography>
                                <Typography textAlign="justify" variant="body2" style={{ textIndent: '2rem' }}>
                                    Chúng tôi không thu thập bất kỳ thông tin thanh toán nào vì các ưu đãi hiện tại của chúng tôi là miễn
                                    phí.
                                </Typography>
                                {/*  */}
                                <Typography variant="h4">Sử Dụng Dữ Liệu:</Typography>
                                <Typography textAlign="justify" variant="body2" style={{ textIndent: '2rem' }}>
                                    YouTeach.AI thu thập và sử dụng dữ liệu cá nhân cho nhiều mục đích khác nhau, đảm bảo cung cấp một dịch
                                    vụ toàn diện và hiệu quả. Các mục đích này bao gồm:
                                </Typography>
                                <ol style={{ listStyleType: 'decimal', marginLeft: '4rem' }}>
                                    <li>
                                        <Typography textAlign="justify" variant="body2">
                                            Cung cấp và Bảo trì Dịch vụ: Chúng tôi sử dụng dữ liệu cá nhân của bạn để cung cấp và duy trì
                                            Dịch vụ của chúng tôi, đảm bảo một trải nghiệm người dùng mượt mà và đáng tin cậy.
                                        </Typography>
                                    </li>
                                    <li>
                                        <Typography textAlign="justify" variant="body2">
                                            Thông báo về Thay đổi: YouTeach.AI thông báo cho bạn về bất kỳ thay đổi nào trong Dịch vụ của
                                            chúng tôi, đảm bảo sự minh bạch và nhận thức.
                                        </Typography>
                                    </li>
                                    <li>
                                        <Typography textAlign="justify" variant="body2">
                                            Các Tính năng Tương tác: Nếu bạn chọn tham gia các tính năng tương tác của Dịch vụ chúng tôi, dữ
                                            liệu cá nhân của bạn được sử dụng để cho phép bạn tương tác khi bạn chọn làm như vậy.
                                        </Typography>
                                    </li>
                                    <li>
                                        <Typography textAlign="justify" variant="body2">
                                            Hỗ trợ Khách hàng: Dữ liệu cá nhân được sử dụng để cung cấp hỗ trợ khách hàng, giải quyết thắc
                                            mắc và đảm bảo sự hài lòng của người dùng.
                                        </Typography>
                                    </li>
                                    <li>
                                        <Typography textAlign="justify" variant="body2">
                                            Phân Tích và Cải Thiện: Chúng tôi thu thập và phân tích dữ liệu để rút ra các thông tin quý báu
                                            giúp cải thiện Dịch vụ của chúng tôi, đảm bảo sự tiến bộ liên tục.
                                        </Typography>
                                    </li>
                                    <li>
                                        <Typography textAlign="justify" variant="body2">
                                            Theo Dõi Việc Sử Dụng: Dữ liệu cá nhân của bạn được sử dụng để theo dõi các mô hình sử dụng Dịch
                                            vụ, giúp chúng tôi hiểu cách người dùng tương tác với nền tảng.
                                        </Typography>
                                    </li>
                                    <li>
                                        <Typography textAlign="justify" variant="body2">
                                            Phát Hiện và Ngăn Chặn Vấn Đề Kỹ Thuật: Chúng tôi sử dụng dữ liệu cá nhân để phát hiện, ngăn
                                            chặn và giải quyết các vấn đề kỹ thuật, đảm bảo an ninh và độ tin cậy của Dịch vụ.
                                        </Typography>
                                    </li>
                                </ol>
                                <Typography textAlign="justify" variant="body2" style={{ textIndent: '2rem' }}>
                                    YouTeach.AI ưu tiên an ninh và quyền riêng tư của dữ liệu cá nhân của bạn, và các thực hành về dữ liệu
                                    của chúng tôi tuân theo cam kết cung cấp một trải nghiệm học tập an toàn và cá nhân hóa.
                                </Typography>
                                {/*  */}
                                <Typography variant="h4">Quyền người dùng:</Typography>
                                <Typography textAlign="justify" variant="body2" style={{ textIndent: '2rem' }}>
                                    Theo đúng với pháp luật Việt Nam, bạn có quyền:
                                </Typography>
                                <ol style={{ listStyleType: 'decimal', marginLeft: '4rem' }}>
                                    <li>
                                        <Typography textAlign="justify" variant="body2">
                                            Yêu cầu truy cập vào dữ liệu cá nhân chúng tôi có về bạn.
                                        </Typography>
                                    </li>
                                    <li>
                                        <Typography textAlign="justify" variant="body2">
                                            Yêu cầu sửa chữa bất kỳ dữ liệu nào không chính xác hoặc không đầy đủ.
                                        </Typography>
                                    </li>
                                    <li>
                                        <Typography textAlign="justify" variant="body2">
                                            Yêu cầu xóa dữ liệu cá nhân của bạn, dưới các điều kiện cụ thể.
                                        </Typography>
                                    </li>
                                    <li>
                                        <Typography textAlign="justify" variant="body2">
                                            Phản đối việc xử lý dữ liệu cá nhân của bạn, trong những trường hợp cụ thể.
                                        </Typography>
                                    </li>
                                </ol>
                                {/*  */}
                                <Typography variant="h4">Thay Đổi Chính Sách: </Typography>
                                <Typography textAlign="justify" variant="body2" style={{ textIndent: '2rem' }}>
                                    Chúng tôi có thể cập nhật chính sách này định kỳ để phản ánh các thay đổi trong thực hành của chúng tôi
                                    hoặc cho các lý do vận hành, pháp lý hoặc quy định khác. Nếu chúng tôi thực hiện những thay đổi quan
                                    trọng, chúng tôi sẽ thông báo cho bạn thông qua nền tảng của chúng tôi hoặc bằng các phương tiện khác để
                                    bạn có cơ hội xem xét các bản sửa đổi trước khi chúng trở nên hiệu quả.
                                </Typography>
                                {/*  */}
                                <Typography variant="h4">Câu Hỏi hoặc Liên Hệ: </Typography>
                                <Typography textAlign="justify" variant="body2" style={{ textIndent: '2rem' }}>
                                    Nếu bạn có bất kỳ câu hỏi nào về chính sách bảo mật này hoặc thực hành dữ liệu của chúng tôi, vui lòng
                                    liên hệ với chúng tôi qua địa chỉ email youteachai.hcm@gmail.com
                                </Typography>
                                <Typography textAlign="justify" variant="body2" style={{ textIndent: '2rem' }}>
                                    Vui lòng sử dụng YouTeach.AI một cách có trách nhiệm, với đảm bảo rằng quyền riêng tư của bạn là ưu tiên
                                    hàng đầu của chúng tôi. Cảm ơn bạn đã lựa chọn tương tác với nền tảng học tập được trang bị trí tuệ nhân
                                    tạo của chúng tôi.
                                </Typography>
                            </Stack>
                        </MainCard>
                    </Grid>
                </Grid>
            </Container>
            <SectionWrapperFooter
                sx={{ bgcolor: theme.palette.mode === 'dark' ? 'background.default' : theme.palette.main.lightItems, pb: 0 }}
            >
                <FooterSection />
            </SectionWrapperFooter>
        </HeaderWrapper>
    );
};

export default PrivacyPolicy;
